import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const control = theme => css`
  min-height: ${rem(44)};
  white-space: normal;
  &:focus-visible,
  &:focus-within {
    outline: ${rem(2)} solid ${theme.color.info['500']};
    outline-offset: ${rem(3)};
  }
`
const actions = css`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(12)};
  > * {
    flex: 1 1 ${rem(160)};
  }
`
const row = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: ${rem(12)};
`
const body = css`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  padding-top: ${rem(24)};
  min-width: 0;
  overflow-wrap: anywhere;
`
const summary = theme => css`
  padding: ${rem(20)};
  background: ${theme.color.info['50']};
  border-radius: ${rem(8)};
  > strong {
    font-size: ${theme.fontSize.x4large};
  }
`
const choices = css`
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  legend {
    margin-bottom: ${rem(16)};
  }
`
const description = css`
  display: block;
  margin-top: ${rem(8)};
`
export const styles = {
  control,
  actions,
  row,
  body,
  summary,
  choices,
  description,
}
